import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { ExperienceContext } from '@thd-nucleus/experience-context';

export const CategoryHeader = ({ title, subtitle, id }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const wrapperCss = classNames('sui-mb-2', {
    'sui-flex sui-flex-col': isMobile,
    'sui-ml-2': !isMobile
  });

  const titleCss = classNames('sui-border-b-2 sui-border-solid sui-border-accent', {
    'sui-text-5xl': !isMobile,
    'sui-text-lg sui-self-center sui-mb-4': isMobile
  });

  const subtitleCss = classNames('sui-font-bold', {
    'sui-text-3xl sui-pl-4 ': !isMobile,
    'sui-text-sm sui-self-center sui-mb-2': isMobile,
  });

  return (
    <Typography component="div" id={id}>
      <div className={wrapperCss}>
        <span className={titleCss}>{title}</span>
        <span className={subtitleCss}>{subtitle}</span>
      </div>
    </Typography>
  );
};

CategoryHeader.displayName = 'CategoryHeader';

CategoryHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  id: PropTypes.string
};

CategoryHeader.defaultProps = {
  title: '',
  subtitle: '',
  id: ''
};
